import * as angular from "angular";
import {IController} from "angular";
import {AccountsContextService} from "../../services/accounts-context.service";

export class CreateOrderOrServiceButton implements IController {

  onCreateService: Function;
  onCreateOrder: Function;

  private siteId: string;
  public loading: boolean;
  public isFieldServiceEnabled: boolean;

  /* @ngInject */
  constructor(private IAMPermissions, private accountsContextService: AccountsContextService, private splitService, private $log) {
    this.siteId = this.splitService.getSiteId();
    const hasFieldServicePermissions = this.IAMPermissions.hasPermission('orders.create') &&
      this.IAMPermissions.hasPermission('orders.operation.create');
    this.isFieldServiceEnabled = this.splitService.isFieldServiceEnabled() && !!hasFieldServicePermissions;
  }

  $onInit() {
    this.loading = false;
  }

  private handleCreateToggle(onCreate: (account) => void) {
    this.loading = true;
    this.accountsContextService.getFavouriteAccount(this.siteId)
      .then((account) => {
        onCreate(account);
      })
      .catch((error) => {
        if (error) {
          this.$log.error(error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onCreateServiceClick($event) {
    this.handleCreateToggle((account) => this.onCreateService({account: account, $event: $event, isOperation: false}));
  }

  onCreateFieldServiceClick($event) {
    this.handleCreateToggle((account) => this.onCreateService({account: account, $event: $event, isOperation: true}));
  }

  onCreateOrderClick() {
    this.handleCreateToggle((account) => this.onCreateOrder({account: account}));
  }
}


angular
  .module('bringoz.admin.commons')
  .component('createOrderOrServiceButton', {
    bindings: {
      onCreateService: '&',
      onCreateOrder: '&'
    },
    template: require('./create-order-or-service-button.html').default,
    controller: CreateOrderOrServiceButton
  });
